/* eslint-disable no-loop-func */
import React, { Component, createRef } from "react";
import ReactDOM from "react-dom";

// CSS
import "./Exams.scss";

// Helper
import { setCookie, checkCookie } from "../../Helper/Cookies";
import { apiFetch, getCurrentUser } from "../../Helper/Api";


// Components
import Header from "../../components/Header/Header";
import { SelectEmpty } from "../../components/UI/Controls";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { FileUpload } from "primereact/fileupload";
// Required component 
// import Lightbox from "react-awesome-lightbox";
// // Required stylesheet
// import "react-awesome-lightbox/build/style.css";
// // Properties
const properties = require("../../properties.json");

class EditCommonExam extends Component {
  constructor(props) {
    super(props);
    this.toast = createRef(null);
  }

  state = {
    // Submit Button
    buttonText: "تعديل السؤال",
    buttonColor: "",

    // Where the save is drawn when this form is mounted inside a panel.
    headerSlot: null,

    // Teacher Identifier
    branchID: getCurrentUser()?.branchId,
    companyID: properties.company_id,
    examID: this.props.questionId
      ? parseInt(this.props.questionId)
      : (this.props.match && this.props.match.params.id) ? parseInt(this.props.match.params.id) : 0,


    // Exam
    // questions: [
    //   {
    //     id: 1,
    //     question: null,
    //     type: null,
    //     img: "",
    //     score: 0,
    //     answers: [
    //       {
    //         answerID: 1,
    //         text: null,
    //         note: null,
    //         correct: null,
    //         parent: 1,
    //         img: null,
    //       },
    //     ],
    //   },
    // ],
    answerContent: {
      image: "",
      text:"",
      id:null

    },   
     img: "",
    question:"",
    questionId:null,
    questionAnswerImage:"",
    questionImage:"",

    numQuestions: 1,
    numAnswers: 1,

    // Get Data
    getSchoolStages: [],

    // every material the teacher has, with its stage name on it -- the
    // options for the one material field, which prefills from the question
    allMaterials: [],
    loadingMaterials: true,
    getLessons: [],
    getPeriods: [],
    getMaterialsList: [],
    // Get Current Answers
    getAnswers: 1,

    // Inputs Data
    selectedLesson: null,
    selectedStage: null,
    selectedStatus: null,
    selectedMonth: null,
    selectedType: null,
    selectedMaterial: null,
    examName: null,
    Timer: 0,
    formContent: {
      type: null,
      id: null,
      branchId: getCurrentUser()?.branchId,
      companyId: properties.company_id,
      mediaType: 0,
      mediaLink: null,
      thumb: null,
    },
    qustionReply:null,
    materialId:null,
    levelId:null,
    qusetionImg:null,
    answer:null,
    answerImg:null,



    selectedPeriod: null,
  };
  getMaterialByStage(stageId){
    apiFetch("/lookup/materials/by-stage", { query: { stageId } })
      .then(grades => {
        this.setState({getMaterialsList : grades});
      })
      .catch(error => console.error('Error:', error));
 }

  // Every material the teacher has, each carrying its own stage name. A
  // question's response has no school stage on it (materials are already
  // stage-scoped), so narrowing by stage left this list empty on edit and the
  // material the question actually has had no option to render -- which is
  // why the dropdown came up blank over a saved question. The flat list needs
  // no stage, so the saved materialId resolves straight away.
  getMaterials = () => {
    const user = getCurrentUser();
    this.setState({ loadingMaterials: true });
    apiFetch("/lookup/materials", { query: { branchId: user?.branchId, teacherUserId: user?.userId } })
      .then(materials => {
        this.setState({ allMaterials: materials, loadingMaterials: false });
      })
      .catch(error => {
        console.error('Error:', error);
        this.setState({ loadingMaterials: false });
      });
  }

  getLessonsByStage = (schoolStagesId,materialId , periodId) => {
    // Get Lessons From API
    apiFetch("/lessons", { query: { materialId, schoolStageId: schoolStagesId, id: periodId } })
      .then((fetchLessons) => {
        this.setState({ getLessons: fetchLessons });
      })
      .catch((error) => console.error("Error:", error));
  };
  getPeriod(materialId) {
    apiFetch("/periods/by-material", { query: { materialId } })
      .then((grades) => {
        this.setState({ getPeriods: grades });
      })
      .catch((error) => console.error("Error:", error));
  }

  // getPeriods() {
  //   var data = JSON.parse(window.localStorage.getItem("currentTeacher"));
  //   fetch(properties.api_path + "/periods/allPeriods", {
  //     method: "POST",
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       branchId: this.state.branchID,
  //     }),
  //   })
  //     .then((res) => {
  //       return res.json();
  //     })
  //     .then((grades) => {
  //       console.log(grades);
  //       this.setState({ getPeriods: grades });
  //     });
  // }
//   getMaterialByStage(stageId){
//     var data =JSON.parse(window.localStorage.getItem('currentTeacher'));
//     fetch(properties.api_path + "/lockup/materialListbystage", {
//         method: "POST",
//         headers: {
//             'Accept': 'application/json',
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//             id: stageId
//         })
//     })
//     .then(res => {return res.json()})
//     .then(grades => {
//         console.log(grades);
//         this.setState({getMaterialsList : grades});
//     })
//  }
  //getMaterialList
  // getMaterial = () => {
  //   // Get Periods From API
  //   var data = JSON.parse(window.localStorage.getItem("currentTeacher"));
  //   fetch(properties.api_path + "/lockup/materialList", {
  //     method: "POST",
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       teacherId: data["teacherId"],
  //       branchId: this.state.branchID,
  //     }),
  //   })
  //     .then((res) => {
  //       return res.json();
  //     })
  //     .then((fetchMaterials) => {
  //       this.setState({
  //         getMaterialsList: fetchMaterials,
  //       });
  //     });
  // };

  componentDidMount() {
    var _this = this;
    // let lightbox = new PhotoSwipeLightbox({
    //     gallery: '#' + props.galleryID,
    //     children: 'a',
    //     pswpModule: () => import('photoswipe'),
    //   });
    //   lightbox.init();
  
    //   return () => {
    //     lightbox.destroy();
    //     lightbox = null;
    //   };
    document.title = properties.site_name + " | تعديل السؤال ";

    if (this.props.inPanel) {
      const slot = document.querySelector(".ui-panel-slot");
      if (slot) this.setState({ headerSlot: slot });
    }
    // Redirect To Sign In Page If The User Is Already Logged Out & Remove The Data If It Exists
    if (!checkCookie("name")) {
      window.localStorage.removeItem("currentTeacher");
      window.location.href = `/`;
    }

    apiFetch("/lookup/school-stages/by-teacher", { query: { teacherUserId: getCurrentUser()?.userId } })
      .then((grades) => {
        this.setState({ getSchoolStages: grades });
      })
      .catch((error) => console.error("Error:", error));

    this.getMaterials();

    // Get Grades From API
    apiFetch(`/common-questions/${this.state.examID}`)
    .then(fetchExam => {
        this.setState({
            qustionReply:fetchExam.text,
            materialId:fetchExam.materialId,
            qusetionImg:fetchExam.image,
            questionId:fetchExam.id,
           answerContent:{
                text: fetchExam.answer ? fetchExam.answer.text : "",
                image: fetchExam.answer ? fetchExam.answer.image : "",
                id: fetchExam.answer ? fetchExam.answer.id : null
            },
            questionAnswerImage: fetchExam.answer ? fetchExam.answer.image : "",
            questionImage:fetchExam.image
            // A question has no school stage (materials are already
            // stage-scoped), which used to mean the material dropdown could
            // not be prefilled -- its options were fetched per stage, so with
            // no stage there were none. The options come from the flat
            // materials lookup now, so this materialId resolves on its own
            // and the stage dropdown is gone.
        });
    })
    .catch(error => {
        console.error('Error:', error)

        _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
    });
  }

  openFullscreen  () {
    document.getElementById('image')?.requestFullscreen()
  }
  // addAnswerImage (url ,index) {
  //  this.setState({questions : {...this.state.questions[this.state.getAnswers -1].answers[index] ,
  //   img : url,
  // }}) ;
  // console.log(this.state.questions[this.state.getAnswers -1].answers[index]);
  // }

  render() {
    // each option names its own stage, so "عربي" under two stages is still
    // told apart without a second field to narrow it down
    let materialList = this.state.allMaterials.map((m) => {
      return {
        label: m.stageName ? `${m.name} — ${m.stageName}` : m.name,
        value: m.id,
      };
    });

    
    let answersInputs =  (
        <div className="p-grid p-fluid answer p-mb-6" >
          <div className="p-col-12 p-md-12 p-p-2">
            <div className="p-inputgroup">
              <span className="p-float-label">
                {/* An answer is a paragraph, not a word: it gets the full
                    width of the section and room to grow. */}
                <InputTextarea
                  id="common-answer-text"
                  rows={4}
                  autoResize
                  value={this.state.answerContent.text}
                  // id={`answer-${answer.answerID}`}
                  // name={`answer-${answer.answerID}`}
                  placeholder="اكتب الإجابة اللي هتظهر للطالب"
                  onChange={(e) => {
                    // let temp = this.state.questions;
                    // var a = temp[getQuestionIndex].answers.findIndex(
                    //   (ans) => ans.answerID === answer.answerID
                    // );
                    // temp[getQuestionIndex].answers[a].text = e.target.value;
                    this.setState({
                      answerContent: {
                        ...this.state.answerContent,
                        text: e.target.value,
                      },
                    });
                
                  }}
                />

                <label htmlFor="common-answer-text">نص الإجابة</label>
              </span>
            </div>
          </div>
          {/* <div className="p-col-12 p-md-2 p-d-flex p-ai-center p-jc-center">
            <div className="p-field-radiobutton p-mb-0">
              <RadioButton
                inputId={`correct-${answer.answerID}`}
                value={1}
                name="correct"
                id={`correct-${answer.answerID}`}
                checked={answer.correct === 1}
                onChange={(e) => {
                  let temp = this.state.questions;
                  var a = temp[getQuestionIndex].answers.findIndex(
                    (ans) => ans.answerID === answer.answerID
                  );
                  for (
                    var c = 0;
                    c < temp[getQuestionIndex].answers.length;
                    c++
                  ) {
                    temp[getQuestionIndex].answers[c].correct = 0;
                  }

                  temp[getQuestionIndex].answers[a].correct = e.value;

                  this.setState({
                    questions: temp,
                  });
                }}
              />
              <label
                className="right-answer"
                htmlFor={`correct-${answer.answerID}`}
              >
                الإجابة الصحيحة
              </label>
            </div>
          </div>
          <div className="p-col-12 p-md-3 p-p-2">
            <div className="p-inputgroup">
              <span className="p-float-label">
                <InputText
                  value={answer.note}
                  id={`note-${answer.answerID}`}
                  name={`note-${answer.answerID}`}
                  type="text"
                  onChange={(e) => {
                    let temp = this.state.questions;
                    var a = temp[getQuestionIndex].answers.findIndex(
                      (ans) => ans.answerID === answer.answerID
                    );
                    temp[getQuestionIndex].answers[a].note = e.target.value;

                    this.setState({
                      questions: temp,
                    });
                  }}
                />

                <label htmlFor={`note-${answer.answerID}`}>ملحوظة</label>
              </span>
            </div>
          </div>
          <div className="p-col-12 p-md-2 p-p-2">
            <Button
              icon="pi pi-trash"
              className="p-button-danger p-button-rounded"
              onClick={() => {
                var temp = this.state.questions;
                temp[getQuestionIndex].answers.splice(i, 1);

                this.setState({
                  questions: temp,
                });
              }}
            />
          </div> */}
          <div className="p-col-12 p-md-12">
            <div className="p-inputgroup">
              <span className="p-float-label">
                <Toast ref={this.toast}></Toast>
                <FileUpload
                  name="thumb"
                  onUpload={(e) => {
                    let res = JSON.parse(e.xhr.response);
                    // let temp = this.state.answerContent;
                    // var q = getQuestionIndex;
                    // var answer = temp[q].answers[i];
                    // temp.image = res.media_url;
                    // console.log(res.thumb_url.split('/'))
                    this.state.questionAnswerImage = res.thumb_url.split(',')[0].split('/')[1];
                    this.setState({
                      answerContent: {
                        ...this.state.answerContent,
                        image:this.state.questionAnswerImage,
                        
                      },
                    
                    });
                    
                    console.log(this.state.questionAnswerImage)

                     this.toast.current.show({
                      severity: "info",
                      summary: "تم بنجاح",
                      detail: "تم رفع الصورة/الفيديو",
                    });
                  }}
                  invalidFileSizeMessageSummary="حجم الصورة كبير:"
                  invalidFileSizeMessageDetail="أقصى حجم للصورة هو (100 MB)"
                  url={`${properties.uploads_path}/upload-thumb.php`}
                  customUpload={false}
                  multiple={false}
                  accept={`${"image/*"}`}
                  maxFileSize={2000000000}
                  chooseLabel="إختيار صوره"
                  uploadLabel="رفع صوره"
                  cancelLabel="إلغاء"
                  emptyTemplate={
                    <p className="p-m-0">إسحب الصورة هنا ليبدأ التحميل</p>
                  }
                />
              </span>
              <img className="preview-thumb" onClick={(e)=>{e.target.requestFullscreen()
            console.log(
                `${properties.uploads_path}/thumb/${this.state.questionAnswerImage}`)
        
        }
            } src={`${properties.uploads_path}/thumb/${this.state.questionAnswerImage}`} alt={this.state.answer} />

            </div>
          </div>
        </div>
      )
    

    let questionsInputs =  (
        <div className="p-grid p-fluid question p-mb-3">
          <div className="p-col-12 p-md-12 p-p-2">
            <div className="p-inputgroup">
              <span className="p-float-label">
                <InputText
                  id="common-question-text"
                  value={this.state.qustionReply}
                  // id={`question-${index}`}
                  // name={`question-${index}`}
                  type="text"
                  placeholder="مثال: إمتى بيبدأ الترم الثاني؟"
                  onChange={(e) => {
                    // let temp = this.state.questions;
                    // var q = temp.findIndex((ques) => ques.id === qn.id);
                    // temp[q].question = e.target.value;
                       this.setState({
                        qustionReply: e.target.value,
                    });
                    
                  }}
                />

                <label htmlFor="common-question-text">نص السؤال</label>
              </span>
            </div>
          </div>
          {/* <div className="p-col-12 p-md-2">
            <div className="p-inputgroup">
              <span className="p-float-label">
                <Dropdown
                  value={qn.type}
                  options={questionType}
                  placeholder="نوع السؤال"
                  onChange={(e) => {
                    let temp = this.state.questions;
                    var q = temp.findIndex((ques) => ques.id === qn.id);
                    temp[q].type = e.value;

                    this.setState({
                      questions: temp,
                    });
                  }}
                  optionLabel="label"
                  showClear
                />
              </span>
            </div>
          </div> */}

          {/* <div className="p-col-12 p-md-2">
            <div className="p-inputgroup">
              <span className="p-float-label">
                <InputText
                  id={`score-${index}`}
                  value={qn.score}
                  name={`score-${index}`}
                  type="number"
                  onChange={(e) => {
                    let temp = this.state.questions;
                    var q = temp.findIndex((ques) => ques.id === qn.id);
                    temp[q].score = e.target.value;

                    this.setState({
                      questions: temp,
                    });
                  }}
                />

                <label htmlFor={`score-${index}`}>الدرجة</label>
              </span>
            </div>
          </div>
          <div className="p-col-12 p-md-2 p-p-2">
            <Button
              icon="pi pi-trash"
              className="p-button-danger p-button-rounded"
              onClick={() => {
                var temp = this.state.questions;
                temp.splice(index, 1);

                this.setState({
                  questions: temp,
                });
              }}
            />
            <Button
              icon="pi pi-list"
              className="p-button-rounded p-button-success p-mr-2"
              onClick={() => {
                this.setState({
                  getAnswers: qn.id,
                });
              }}
            />
          </div> */}

          
          <div className="p-col-12 p-md-12">
            <div className="p-inputgroup">
              <span className="p-float-label">
                <Toast ref={this.toast}></Toast>
                <FileUpload
                  name="thumb"
                  onUpload={(e) => {
                    let res = JSON.parse(e.xhr.response);
                    console.log(res)
                    // let temp = this.state.questions;
                    // var q = temp.findIndex((ques) => ques.id === qn.id);
                    // temp[q].img = res.media_url;
                    // console.log(res.media_url);
                    // this.setState({ questions: temp });
                    this.state.questionImage = res.thumb_url.split(',')[0].split('/')[1];
                    this.setState({
                      img: this.state.questionImage,
                  });
                    this.toast.current.show({
                      severity: "info",
                      summary: "تم بنجاح",
                      detail: "تم رفع الصورة/الفيديو",
                    });
                    // console.log(this.state.questions);
                  }}
                  invalidFileSizeMessageSummary="حجم الصورة/الفيديو كبير:"
                  invalidFileSizeMessageDetail="أقصى حجم للصورة/فيديو هو (200 MB)"
                  url={`${properties.uploads_path}/upload-thumb.php`}
                  customUpload={false}
                  multiple={false}
                  accept={`${
                    this.state.formContent.mediaType === 1
                      ? "video/*"
                      : "image/*"
                  }`}
                  maxFileSize={2000000000}
                  chooseLabel="إختيار صوره"
                  uploadLabel="رفع صوره"
                  cancelLabel="إلغاء"
                  emptyTemplate={
                    <p className="p-m-0">إسحب الصورة هنا ليبدأ التحميل</p>
                  }
                />
              </span>
              {/* <ImageGallary
      items={[`${properties.uploads_path}/${this.state.qusetionImg}`]}
      showThumbnails={true}
      showFullscreenButton={true}
    //   showPlayButton={false}
    //   showBullets={true}
    //   ref={imageGalleryRef}
    //   onClick={onClickHandler}
    /> */}
    {/* <Lightbox image={`${properties.uploads_path}/${this.state.qusetionImg}`} title="Image Description" /> */}
              <img className="preview-thumb image" src={`${properties.uploads_path}/thumb/${this.state.questionImage}`} alt={this.state.question} onClick={(e)=>e.target.requestFullscreen()}/>

            </div>
          </div>
        </div>
      );
    

    let gradesList = this.state.getSchoolStages.map((grade) => {
      return {
        label: grade.name,
        value: grade.id,
      };
    });

    let lessonsList = this.state.getLessons.map((lessons) => {
      return {
        label: lessons.lessonName,
        value: lessons.id,
      };
    });

    var addExam = (e) => {
      var _this = this;

      // let total = 0;

      // for (var i = 0; i < this.state.questions.length; i++) {
      //   total += parseFloat(this.state.questions[i].score);
      // }

      // console.log(total);

      this.setState({
        buttonText: "جاري الإضافة ...",
        buttonColor: "loading",
      });

      // var finalQuestionsForm = [];

      // for (var q = 0; q < this.state.questions.length; q++) {
      //   var finalAnswers = [];

      //   for (var a = 0; a < this.state.questions[q].answers.length; a++) {
      //     finalAnswers.push({
      //       companyId: this.state.companyID,
      //       branchId: this.state.branchID,
      //       answer: this.state.questions[q].answers[a].text,
      //       img: this.state.questions[q].answers[a].img,
      //       // correct: this.state.questions[q].answers[a].correct,
      //       // reason: this.state.questions[q].answers[a].note,
      //     });
      //   }

      //   finalQuestionsForm.push({
      //     companyId: this.state.companyID,
      //     branchId: this.state.branchID,
      //     questionName: this.state.questions[q].question,
      //     // questionType: this.state.questions[q].type,
      //     img: this.state.questions[q].img,
      //     // questionDegree: this.state.questions[q].score,
      //     answersdtoList: finalAnswers,
      //   });
      // }

      // console.log(finalQuestionsForm);

      // Send the data to the server
      apiFetch(`/common-questions/${this.state.questionId}`, {
        method: "PUT",
        body: {
          text: this.state.qustionReply,
          image: this.state.questionImage,
          branchId: this.state.branchID,
          materialId: this.state.materialId,
          answer: {
            text: this.state.answerContent.text,
            image: this.state.answerContent.image,
          },
        },
      })
        .then(() => {
          _this.setState({
            buttonText: "إضافة سؤال",
            buttonColor: "",
          });

          _this.toast.current.show({
            severity: "success",
            summary: "تم بنجاح",
            detail: "تم تعديل السؤال بنجاح",
          });

          // in a panel the save closes it and the list refetches; on the
          // /commonQuestions/edit/:id page it reloads exactly as before
          if (_this.props.onSaved) _this.props.onSaved();
          else window.location.reload();
        })
        .catch((error) => {
          console.error("Error:", error);

          _this.setState({
            buttonText: "إضافة سؤال",
            buttonColor: "",
          });

          _this.toast.current.show({
            severity: "error",
            summary: "لم تتم العملية",
            detail: error.message || "خطأ في الإتصال",
          });
        });
    };
   

    return (
      // `inPanel` is presentation only -- the route still mounts this same
      // component as its own page.
      <div className={this.props.inPanel ? "add-lesson-page in-panel" : "add-lesson-page"}>
        {this.props.inPanel ? null : <Header pageName="تعديل سؤال شائع " />}

        <div className="content">
          <Toast ref={this.toast}></Toast>

          <div className="container">
            <Card title={this.props.inPanel ? null : "تعديل سؤال شائع "}>
              <form
                onSubmit={(e) => e.preventDefault()}
                action="#"
                method="POST"
              >
                <section className="ui-sec" style={{ "--d": "0ms" }}>
                <h3>
                  <span className="n">١</span>
                  <span className="t">
                    مكان السؤال
                    <small>السؤال بيتبع مادة — كل مادة مكتوب جنبها مرحلتها</small>
                  </span>
                </h3>
                <div className="p-grid p-fluid">
               
                  {/* One field, not a stage -> material cascade. A question
                      carries no stage, so the cascade left this blank over a
                      saved question; each option names its own stage instead. */}
                  <div className="p-col-12 p-md-4">
                    <div className="p-inputgroup">
                      <span className="p-float-label">
                        <Dropdown
                          value={this.state.materialId}
                          options={materialList}
                          placeholder="اختر"
                          onChange={(e) =>
                            this.setState({ materialId: e.value }
                              ,this.getPeriod(e.value), this.getLessonsByStage(
                                this.state.levelId,
                                e.value,
                                this.state.selectedPeriod
                              ),
                              )



                          }
                          optionLabel="label"
                          showClear
                          emptyMessage={<SelectEmpty loading={this.state.loadingMaterials} />}
                        />
                        <label>المادة</label>
                      </span>
                    </div>
                  </div>


                </div>
                </section>
              </form>
            </Card>

            <section className="ui-sec questions" style={{ "--d": "70ms" }}>
              <h3>
                <span className="n">٢</span>
                <span className="t">
                  السؤال
                  <small>نص السؤال، وصورة توضحه لو محتاج</small>
                </span>
              </h3>
             

              {questionsInputs}
            </section>

            <section className="ui-sec questions" style={{ "--d": "140ms" }}>
              <h3>
                <span className="n">٣</span>
                <span className="t">
                  الإجابة
                  <small>الإجابة اللي هتظهر للطالب تحت السؤال</small>
                </span>
              </h3>
              {/* <Button
                label="إضافة إجابة"
                icon="pi pi-plus"
                className="p-mb-5 add-question"
                onClick={(e) => {
                  this.setState(
                    {
                      numAnswers: this.state.numAnswers + 1,
                    },
                    () => {
                      let temp = this.state.questions;

                      temp[getQuestionIndex].answers.push({
                        answerID: this.state.numAnswers,
                        text: null,
                        note: null,
                        parent: this.state.getAnswers,
                      });

                      this.setState({
                        questions: temp,
                      });
                    }
                  );
                }}
              /> */}

              {answersInputs}
            </section>

            {/* in a panel the save rides the header row, on the page it keeps
                its own bar at the end of the form */}
            {this.state.headerSlot ? (
              ReactDOM.createPortal(
                <Button
                  onClick={addExam}
                  className={`add-button ${this.state.buttonColor}`}
                  label={this.state.buttonText}
                />,
                this.state.headerSlot
              )
            ) : (
              <Card className="p-mt-5">
                <div className="p-col-12 p-md-12 p-mt-2">
                  <div className="p-inputgroup">
                    <span className="p-float-label">
                      <Button
                        onClick={addExam}
                        className={`add-button ${this.state.buttonColor}`}
                        label={this.state.buttonText}
                      />
                    </span>
                  </div>
                </div>
              </Card>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default EditCommonExam;
